import React from "react";
import {
  FiDatabase,
  FiFileText,
  FiActivity,
  FiBarChart2,
} from "react-icons/fi";

const Dashboard = () => {
  // const cards = [
  //   { color: "linear-gradient(45deg, #165A98, #0097D7)" },
  //   { color: "linear-gradient(45deg, #165A98, #0097D7)" },
  //   { color: "linear-gradient(45deg, #165A98, #0097D7)" },
  //   { color: "linear-gradient(45deg, #165A98, #0097D7)" },
  // ];
  const cards = [
    {
      color: "linear-gradient(45deg, #165A98, #0097D7)",
      value: "390M",
      title: "MRF Record Count",
      icon: <FiDatabase size={32} />,
    },
    {
      color: "linear-gradient(45deg, #165A98, #0097D7)",
      value: "19",
      title: "Total Number of Carriers",
      icon: <FiFileText size={32} />,
    },
    {
      color: "linear-gradient(45deg, #165A98, #0097D7)",
      value: "250",
      title: "Total Networks",
      icon: <FiActivity size={32} />,
    },
    {
      color: "linear-gradient(45deg, #165A98, #0097D7)",
      value: "607K",
      title: "Billing NPI Count",
      icon: <FiBarChart2 size={32} />,
    },
  ];

  // const cardStyle = (bg) => ({
  //   background: bg,
  //   color: "white",
  //   padding: "20px",
  //   borderRadius: "10px",
  //   width: "280px",

  //   display: "flex",
  //   flexDirection: "column",
  //   justifyContent: "center",
  // });

  // const numberStyle = {
  //   fontSize: "24px",
  //   fontWeight: "bold",
  //   marginBottom: "5px",
  // };

  // const labelStyle = {
  //   fontSize: "14px",
  // };

  // return (
  //   <div style={{}}>
  //     <div style={{ display: "flex", justifyContent: "space-between" }}>
  //       {cards.map((card, idx) => (
  //         <div key={idx} style={cardStyle(card.color)}>
  //           <div style={numberStyle}>390M</div>
  //           <div style={labelStyle}>MRF Record Count</div>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );

  const cardStyle = (bg) => ({
    background: bg,
    color: "white",
    padding: "20px",
    borderRadius: "10px",
    width: "280px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  });

  const innerContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const numberLabelGroup = {
    display: "flex",
    flexDirection: "column",
  };

  const numberStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "5px",
  };

  const labelStyle = {
    fontSize: "14px",
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "20px",
        }}
      >
        {cards.map((card, idx) => (
          <div key={idx} style={cardStyle(card.color)}>
            <div style={innerContainerStyle}>
              <div style={numberLabelGroup}>
                <div style={numberStyle}>{card.value}</div>
                <div style={labelStyle}>{card.title}</div>
              </div>
              {card.icon}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
